import template from './template.html';
import './style.less';

function generateLabel(gauge) {
  const label = {
    true: {
      tooltip:
        'These hours are optional and the total number you can earn for credit is limited. Once the gauge is full you can no longer earn credit for this category.',
      class: 'label-default',
      text: 'Optional'
    },
    false: {
      tooltip: 'These hours are required. Once the gauge is full the requirement has been met.',
      class: 'label-info',
      text: 'Required'
    }
  }[!!gauge.units];

  if (gauge.badge) label.text = gauge.badge;
  if (gauge.badge_color) label.class = gauge.badge_color;
  if (gauge.badge_tooltip) label.tooltip = gauge.badge_tooltip;

  return label;
}

export default function() {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      id: '<',
      value: '<',
      gauge: '<',
      max: '<',
      compliance: '<'
    },
    template: template,
    controller: function($scope, $filter) {
      'ngInject';

      const nameObj = {
        'Accounting Auditing': 'A&A',
        'Accounting Auditing Ethics': 'A&A Ethics',
        'Government Accounting Auditing': 'Governmental A&A',
        'Accounting Auditing Tax': 'A&A & Tax',
        'Personal Development': 'Personal Dev.',
        'Strategic Business Management': 'Strategic & Business Management',
        'Management Operations': 'Management & Operations',
        'Business Acumen Specialized Knowledge': 'Business Acumen / Specialized Knowledge',
        'Income Franchise Taxation': 'Income / Franchise Taxation',
        'Diversity Inclusion and Elimination of Bias': 'Diversity, Inclusion and Elimination of Bias',
        'Law Practice Management and or Areas of Professional Practice':
          'Law Practice Management and/or Areas of Professional Practice'
      };

      if ($scope.max !== undefined) $scope.gauge.max = $scope.max;

      if (
        $scope.gauge &&
        $scope.gauge.span &&
        $scope.gauge.category &&
        $scope.compliance &&
        $scope.compliance.span &&
        $scope.compliance.span[$scope.gauge.category]
      ) {
        $scope.value = $scope.compliance.span[$scope.gauge.category].total;
      }

      const diff = ($scope.gauge.max || 0) - ($scope.value || 0);
      const remaining = diff > 0 ? diff : 0;

      $scope.gauge.text = 'Remaining:';
      $scope.gauge.secondary_text = ` ${$filter('number')(remaining, 1)} Hour${diff === 1 ? '' : 's'}`;

      if ($scope.gauge.units) {
        $scope.gauge.max = Number($scope.value || 0);
        $scope.gauge.text = 'No Minimum Requirement';
        delete $scope.gauge.secondary_text;
      }

      const percentage = $filter('Progress')($scope.value, $scope.gauge.max);

      $scope.category = nameObj[$scope.gauge.name] === undefined ? $scope.gauge.name : nameObj[$scope.gauge.name];
      $scope.gaugeValues = [];
      $scope.colorDict = {};
      $scope.newId = $scope.id.split(' ').join('');
      $scope.gaugeValues[0] = {};
      $scope.gaugeValues[0][$scope.newId] = $scope.value || 0;

      $scope.label = generateLabel($scope.gauge);
      $scope.gaugeUnits = 'Hours Earned';

      if ($scope.gauge.hide_units) delete $scope.gaugeUnits;

      if ($scope.gauge.gauge_color) return ($scope.colorDict[$scope.newId] = $scope.gauge.gauge_color);
      if ($scope.gauge.value === 'nontech') return ($scope.colorDict[$scope.newId] = '#72C02C');
      if (percentage >= 66) return ($scope.colorDict[$scope.newId] = '#72C02C');
      if (percentage >= 33 && percentage < 66) return ($scope.colorDict[$scope.newId] = '#f8ac59');
      $scope.colorDict[$scope.newId] = '#ED5565';
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/complianceGauge/index.js